import { View } from 'app/scripts/views/internal/view';
import { template } from 'app/scripts/views/templates/search_help_popover';

interface EmptyViewOptions {}

export class SearchHelpView extends View<EmptyViewOptions> {
  viewTitleKey = 'help';

  render() {
    this.$el.html(template());

    return this;
  }
}
